import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import moment from "moment";

class SpecialAvailability extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedDateRangeIndex: 0
        };
    }

    changeDates = (selectedDateRangeIndex) => {
        this.setState({
            selectedDateRangeIndex
        });
    };

    render() {
        const { specialAvailability } = this.props;

        if (specialAvailability === false || !specialAvailability.length) {
            return (
                <div className="d-flex mt-4 mb-4 justify-content-center align-content-center text-danger">
                    No Special Availability
                </div>
            );
        }

        const { selectedDateRangeIndex } = this.state;
        const currentSpecialAvailability = specialAvailability[selectedDateRangeIndex] || false;
        const dailyAvailabilities = currentSpecialAvailability
            ? currentSpecialAvailability.dailyAvailabilities
            : false;

        let dailyAvailabilitiesArray = [];
        if (dailyAvailabilities) {
            dailyAvailabilitiesArray = Object.keys(dailyAvailabilities)
                .map((key) => dailyAvailabilities[key]);
        }

        return (
            <div className="row mt-2">
                <div className="col-6">
                    <div className="mb-2 text-center">
                        Please click to view the detail of an availability
                    </div>
                    {Array.isArray(specialAvailability) ?
                        <ReactTable
                            data={specialAvailability}
                            headerClassName="table-header"
                            columns={[{
                                Header: "Start",
                                headerClassName: "text-left",
                                Cell: ({ original }) =>
                                    (original.startDate ? moment(original.startDate).format("YYYY-MM-DD") : null)
                            }, {
                                Header: "End",
                                headerClassName: "text-left",
                                Cell: ({ original }) =>
                                    (original.endDate ? moment(original.endDate).format("YYYY-MM-DD") : null)
                            }]}
                            getTrProps={(state, rowInfo) => {
                                if (rowInfo && rowInfo.row) {
                                    return {
                                        onClick: () => {
                                            this.changeDates(rowInfo.index);
                                        },
                                        style: {
                                            background: rowInfo.index === this.state.selectedDateRangeIndex ? "#00AFEC" : "white",
                                            color: rowInfo.index === this.state.selectedDateRangeIndex ? "white" : "black",
                                            cursor: "pointer"
                                        }
                                    };
                                }
                                return {};
                            }}
                            defaultPageSize={specialAvailability.length}
                            showPagination={false}
                            className="-striped -highlight"
                            NoDataComponent={() => null}
                        />
                        : null}
                </div>
                {dailyAvailabilitiesArray.length ?
                    <div className="col-6">
                        <div className="mb-2 text-center">
                            {(currentSpecialAvailability.startDate
                                ? moment(currentSpecialAvailability.startDate).format("YYYY-MM-DD")
                                : null)}
                            {(currentSpecialAvailability.endDate
                                ? ` - ${moment(currentSpecialAvailability.endDate)
                                    .format("YYYY-MM-DD")}`
                                : null)}
                        </div>
                        <ReactTable
                            data={dailyAvailabilitiesArray}
                            headerClassName="table-header"
                            columns={[{
                                Header: "",
                                headerClassName: "text-left",
                                Cell: ({ original, index }) => moment.weekdays(true, index)
                            }, {
                                Header: "Start",
                                headerClassName: "text-left",
                                Cell: ({ original }) =>
                                    original.start
                            }, {
                                Header: "End",
                                headerClassName: "text-left",
                                Cell: ({ original }) =>
                                    original.end
                            }, {
                                Header: "Daily Hour",
                                headerClassName: "text-left",
                                Cell: ({ original }) =>
                                    original.availableHours
                            }]}
                            defaultPageSize={dailyAvailabilitiesArray.length}
                            className="-striped -highlight"
                            showPagination={false}
                            NoDataComponent={() => null}
                        />
                    </div>
                : null}
            </div>
        );
    }
}

SpecialAvailability.propTypes = {
    specialAvailability: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]).isRequired
};

export default SpecialAvailability;
